import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {DictResponse} from './dict-response';
import {environment} from '../../environments/environment';
import {MasbitHttpService} from '../../common/http/masbit-http.service';
import {Observable} from "rxjs";
import {BackendServiceResponse} from "../../model/backend-service-response";
import {Report} from "../../model/report";
import {BackendServiceMessage} from "../../model/backend-service-message";
import index from "@angular/cli/lib/cli";

@Injectable()
export class ActivateService {

  static readonly DICT_CLIENT_URL = environment.apiUrl.concat(environment.dictClientGroupUrl);
  static readonly DICT_INSTITUTION_URL = environment.apiUrl.concat(environment.dictInstitutionUrl);
  static readonly DICT_PRODUCT_URL = environment.apiUrl.concat(environment.dictProductUrl);
  static readonly DICT_INTEREST_AREA_URL = environment.apiUrl.concat(environment.dictInterestAreaUrl);
  static readonly ACTIVATE_SERVICE_URL = environment.apiUrl.concat(environment.activateServiceUrl);
  static readonly SAVEPREFERENCES_SERVICE_URL = environment.apiUrl.concat(environment.savePreferencesUrl);
  static readonly DICT_PUBLICATION_FREQUENCY = environment.apiUrl.concat(environment.dictPublicationFrequency);
  static readonly DICT_CONTENT_TYPE = environment.apiUrl.concat(environment.dictContent_type);

  constructor(private httpClient: MasbitHttpService) { }

  getDictProduct() {
    return this.httpClient.get<Array<DictResponse>>(ActivateService.DICT_PRODUCT_URL);
  }

  getDictInstitution() {
    return this.httpClient.get<Array<DictResponse>>(ActivateService.DICT_INSTITUTION_URL);
  }

  getDictClient() {
    return this.httpClient.get<Array<DictResponse>>(ActivateService.DICT_CLIENT_URL);
  }

  getDictInterestArea() {
    return this.httpClient.get<Array<DictResponse>>(ActivateService.DICT_INTEREST_AREA_URL);
  }

  getDictPublicationFrequency() {
    return this.httpClient.get<Array<DictResponse>>(ActivateService.DICT_PUBLICATION_FREQUENCY);
  }
  getDictContentType() {
    return this.httpClient.get<Array<DictResponse>>(ActivateService.DICT_CONTENT_TYPE);
  }

  activate(activationToken: string) : Observable<BackendServiceMessage<number, string>> {
    return this.httpClient.get<BackendServiceMessage<number, string>>(ActivateService.ACTIVATE_SERVICE_URL, new HttpParams().set('token', activationToken));
  }

  savePreferences(activationToken: string,
                  productsSelected : Array<number>,
                  institutionsSelected : Array<number>,
                  clientGroupsSelected : Array<number>,
                  interestAreasSelected : Array<number>,
                  interestProductsUser : string,
                  interestInstitutionsUser : string,
                  interestAreasUser : string,
                  interestClientGroupsUser : string,
                  notifications : number,
                  personalDataProcessingAgreement : boolean,
                  marketingProcessingAgreement : boolean

                  ) : Observable<BackendServiceMessage<number, string>>
  {
    let params = {
      'activationtoken': activationToken,
      'interests_products': productsSelected,
      'interests_institutions' : institutionsSelected,
      'interests_client_groups' : clientGroupsSelected,
      'interests_areas' : interestAreasSelected,
      'interest_products_user' : interestProductsUser,
      'interest_institutions_user' : interestInstitutionsUser,
      'interest_areas_user' : interestAreasUser,
      'interest_client_groups_user' : interestClientGroupsUser,
      'notifications' : notifications,
      'personalDataProcessingAgreement' : personalDataProcessingAgreement,
      'marketingProcessingAgreement' : marketingProcessingAgreement
    };

    return this.httpClient.post<BackendServiceMessage<number, string>>(ActivateService.SAVEPREFERENCES_SERVICE_URL, params);
  }
}
